<template>
  <div class="_rfp_mctb_list_001_ modal-vue">
    <div class="_rfp_mctb_list_002_ modal-vue--content space-content">
      <div class="_rfp_mctb_list_003_ modal-vue--content-panel space-content">
        <h1 class="_rfp_mctb_list_004_ heading">{{ carouselHeaderText }}</h1>

        <div class="_rfp_mctb_list_005_ vue-tabs">
          <section
            v-if="storeLocatorModeOptions.Product.Retailers.length === 0"
            class="_rfp_mctb_list_0018_ tab-container"
          >
            <ul role="generic" class="_rfp_mctb_list_0013_">
              <li role="generic" class="retailer__unavailable">
                <div class="retailer-unavailable_01">
                  {{ retailerUnavailable }}
                </div>
              </li>
            </ul>
          </section>

          <template v-else>
            <div v-if="showTabs" class="_rfp_mctb_list_006_ nav-tabs-navigation">
              <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
                <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                  <li
                    v-for="(country, index) in countriesWithRetailers"
                    :id="country.Name"
                    :key="country.Name"
                    role="tab"
                    tabindex="0"
                    :aria-selected="String(index === activeTabIndex)"
                    aria-controls="rfp-mctb-retailer-tabpanel"
                    class="_rfp_mctb_list_009_ tab active"
                    :class="{ active__tab: index === activeTabIndex }"
                    @keydown.space.prevent="setActiveTab(index)"
                    @keydown.enter="setActiveTab(index)"
                    @click="setActiveTab(index)"
                  >
                    <span class="_rfp_mctb_list_0010_ active_tab tabs__link">
                      <span class="_rfp_mctb_list_0011_ title title_center">
                        {{ country.DisplayName }}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="_rfp_mctb_list_0012_ tab-content">
              <section
                id="rfp-mctb-retailer-tabpanel"
                :role="showTabs ? 'tabpanel' : null"
                class="_rfp_mctb_list_0018_ tab-container"
              >
                <ul class="_rfp_mctb_list_0013_">
                  <li
                    v-for="retailer in computedRetailers"
                    :key="retailer.Name"
                    class="_rfp_mctb_list_0014_"
                  >
                    <span class="_rfp_mctb_list_0015_">
                      <img class="_rfp_mctb_list_0016_" :src="retailer.Logo" alt="" />
                    </span>
                    <span class="_rfp_mctb_list_0017_ buy-button">
                      <a
                        class="rfp-mctb-list__item-link"
                        :href="retailer.RetailerUrl"
                        @click.prevent="
                          pageRedirectUrl(
                            retailer.RetailerUrl,
                            retailer.OpenInNewWindow,
                            retailer.RetailerTags,
                            retailer.RetailerTagsGS,
                            retailer.Name,
                          )
                        "
                      >
                        {{ retailer.Name }}
                      </a>
                    </span>
                  </li>
                </ul>
              </section>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-list-mode',
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: false,
    },
    carouselHeaderText: {
      type: String,
      required: false,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
    initialExtraParams: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      eventProjectDataLayer: {},
      activeTabIndex: 0,
      areaValue: true,
      extraParams: this.initialExtraParams,
    };
  },
  computed: {
    countriesWithRetailers() {
      return this.storeLocatorModeOptions.CountryList.filter((item) => {
        return item.Name in this.retailersByCountryName;
      });
    },
    activeTabCountry() {
      return this.countriesWithRetailers[this.activeTabIndex];
    },
    retailersByCountryName() {
      return this.storeLocatorModeOptions.Product.Retailers.reduce((acc, item) => {
        acc[item.Country] ||= [];
        acc[item.Country].push(item);
        return acc;
      }, {});
    },
    activeCountryTabRetailers() {
      return this.retailersByCountryName[this.activeTabCountry?.Name] || [];
    },
    computedRetailers() {
      if (this.countriesWithRetailers.length > 0) {
        return this.activeCountryTabRetailers;
      }
      return this.storeLocatorModeOptions.Product.Retailers || [];
    },
    showTabs() {
      return this.storeLocatorModeOptions.CountryList.length > 1;
    },
  },
  created() {
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(`error/rfp-mctb-list-mode#pageRedirectUrl: ${service} tag parsing failed`, e);
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    setActiveTab(index) {
      this.activeTabIndex = index;
    },
  },
};
</script>
